module.exports = __webpack_public_path__ + "static/media/bird.2e2c6dbb.svg";